import { render } from "./SeIbvk.vue?vue&type=template&id=16b4bc87"
import script from "./SeIbvk.vue?vue&type=script&lang=js"
export * from "./SeIbvk.vue?vue&type=script&lang=js"

import "./SeIbvk.vue?vue&type=style&index=0&id=16b4bc87&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__